/*
  SalonID — taalsuggestie (zie snippets/sid-lang-suggest.liquid).
  Toont één keer een kaartje met de taal van de markt van de bezoeker (land eerst),
  en de browsertaal als tweede link als die anders is. Stuurt nooit automatisch door.
*/
(function () {
  var STORAGE_KEY = 'sid-langsug';
  var LOCAL = ['NL', 'BE'];
  // markt (land) → taal van die markt
  var COUNTRY_LANG = {
    NL: 'nl', DE: 'de', AT: 'de', FR: 'fr', MC: 'fr', IE: 'en', GB: 'en', IT: 'it', ES: 'es', PT: 'pt-PT',
    DK: 'da', SE: 'sv', NO: 'nb', FI: 'fi', PL: 'pl', CZ: 'cs'
  };
  // meertalige landen: de browsertaal telt als die een van de landstalen is
  var MULTI = { BE: ['nl', 'fr'], LU: ['fr', 'de'] };

  function read(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function write(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* privévenster: dan maar elke keer */ }
  }

  // "pt-BR" -> "pt-PT", "no"/"nn" -> "nb", "en-GB" -> "en"
  function match(tag, available) {
    var lower = String(tag || '').toLowerCase();
    var primary = lower.split('-')[0];
    if (primary === 'no' || primary === 'nn') primary = 'nb';
    for (var i = 0; i < available.length; i++) {
      if (available[i].toLowerCase() === lower) return available[i];
    }
    for (var j = 0; j < available.length; j++) {
      if (available[j].toLowerCase().split('-')[0] === primary) return available[j];
    }
    return null;
  }

  /*
    Welke taal stellen we voor? Geeft { primary, secondary } of null (geen kaartje).
    current = paginataal, available = aangeboden talen, langs = browsertalen, country = Shopify.country
  */
  function decide(current, available, langs, country) {
    // browsertaal: de eerste die we aanbieden
    var browser = null;
    for (var i = 0; i < langs.length && !browser; i++) browser = match(langs[i], available);
    // de bezoeker leest de pagina al in zijn eigen taal
    if (browser && browser === current) return null;
    // NL/BE op de NL- of FR-versie: alleen Nederlands↔Frans voorstellen, geen Engels
    // (veel Nederlanders en Belgen hebben een Engelse browser maar willen gewoon NL)
    if (country && LOCAL.indexOf(country) !== -1 && (current === 'nl' || current === 'fr')) {
      return (browser === 'nl' || browser === 'fr') ? { primary: browser, secondary: null } : null;
    }

    // land eerst: de taal van de markt
    var market = COUNTRY_LANG[country] || null;
    if (!market && MULTI[country] && MULTI[country].indexOf(browser) !== -1) market = browser;
    if (market && available.indexOf(market) === -1) market = null;

    var primary = market || browser;
    if (!primary || primary === current) return null;
    return { primary: primary, secondary: (browser && browser !== primary) ? browser : null };
  }

  function init() {
    var dataEl = document.getElementById('SidLangSuggestData');
    var card = document.querySelector('[data-sid-langsug]');
    var form = document.getElementById('SidLangSuggestForm');
    if (!dataEl || !card || !form || read(STORAGE_KEY)) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var current = data.current;
    var langs = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language];
    var choice = decide(current, data.available, langs, window.Shopify && window.Shopify.country);
    if (!choice || !data.strings[choice.primary]) return;
    var primary = choice.primary;
    var secondary = (choice.secondary && data.strings[choice.secondary]) ? choice.secondary : null;

    var s = data.strings[primary];
    card.lang = primary;
    card.setAttribute('aria-label', s.text);
    card.querySelector('[data-sid-langsug-text]').textContent = s.text;
    card.querySelector('[data-sid-langsug-go]').textContent = s.go;
    card.querySelector('[data-sid-langsug-stay]').textContent = s.stay;
    card.querySelector('[data-sid-langsug-close]').setAttribute('aria-label', s.close);
    var altButton = card.querySelector('[data-sid-langsug-alt]');
    if (secondary) {
      altButton.textContent = data.strings[secondary].alt;
      altButton.lang = secondary;
      altButton.hidden = false;
      // twee keuzes + kruisje is genoeg; "Nee, bedankt" alleen bij één keuze
      card.querySelector('[data-sid-langsug-stay]').hidden = true;
    }

    function dismiss() {
      write(STORAGE_KEY, 'off');
      card.hidden = true;
    }
    function choose(code) {
      write(STORAGE_KEY, 'chosen');
      form.querySelector('[data-sid-langsug-code]').value = code;
      form.submit();
    }
    card.querySelector('[data-sid-langsug-stay]').addEventListener('click', dismiss);
    card.querySelector('[data-sid-langsug-close]').addEventListener('click', dismiss);
    card.querySelector('[data-sid-langsug-go]').addEventListener('click', function () { choose(primary); });
    altButton.addEventListener('click', function () { if (secondary) choose(secondary); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !card.hidden) dismiss();
    });

    // boven een vaste onderbalk blijven (samplebox, koopbalk op mobiel), niet eroverheen
    function clearBottomBars() {
      var vh = window.innerHeight;
      var lift = 0;
      document.querySelectorAll('body *').forEach(function (el) {
        if (el === card || card.contains(el)) return;
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' || cs.visibility === 'hidden' || cs.display === 'none') return;
        var r = el.getBoundingClientRect();
        // brede balk tegen de onderrand; kleine knopjes (chat) laten we liggen
        if (r.height > 0 && r.height < vh / 3 && r.width > window.innerWidth * 0.6 && vh - r.bottom < 24) {
          lift = Math.max(lift, vh - r.top);
        }
      });
      card.style.bottom = lift ? 'calc(' + Math.round(lift + 12) + 'px + env(safe-area-inset-bottom, 0px))' : '';
    }

    // pas na de eerste indruk tonen, niet tussen het laden door
    window.setTimeout(function () {
      card.hidden = false;
      clearBottomBars();
    }, 1200);
    window.addEventListener('resize', function () { if (!card.hidden) clearBottomBars(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
